import { render, staticRenderFns } from "./InformationAboutBooks.vue?vue&type=template&id=caf82066&"
import script from "./InformationAboutBooks.vue?vue&type=script&lang=js&"
export * from "./InformationAboutBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports